import React from 'react';
import _merge from 'lodash/merge';
import Tokens from '@nokia-csf-uxr/freeform-design-tokens';
import { getContext } from 'common';
import Typography from 'components/Typography';

const ERROR_TYPOGRAPHY_CONFIG = ({ content, container }) => ({
  role: 'alert',
  style: {
    ...Tokens.TYPOGRAPHY.CAPTION,
    boxSizing: 'border-box' as const,
    backgroundColor: container,
    color: content,
    padding: `${Tokens.SPACING.SPACING_4} ${Tokens.SPACING.SPACING_24}`,
    flex: 'initial',
    maxWidth: '0',
    width: '100%',
    minWidth: '100%',
    flexShrink: 0
  }
});

export interface CalendarErrorMessageProps extends React.ComponentPropsWithRef<'div'> {
  /** The error message. */
  children?: string;
  /** To override the theme please refer to the "Readme" tab to learn more. */
  theme?: any;
}

/**
 * Any other props than the `CalendarErrorMessage` props will be provided to the <Typography /> component.
 * To get the ref of the outermost element use `ref` prop. [Read React useRef hook documentation](https://reactjs.org/docs/hooks-reference.
 * */
const CalendarErrorMessage = React.forwardRef<HTMLElement, CalendarErrorMessageProps>((props: CalendarErrorMessageProps, ref) => getContext(({ theme }) => {
  const {
    theme: themeProps,
    children,
    ...otherProps
  } = props;
  const typographyProps = {
    ...ERROR_TYPOGRAPHY_CONFIG(_merge({}, theme.CALENDAR.ERROR)),
    ...otherProps
  };
  return children !== undefined && <Typography ref={ref} {...typographyProps}>{children}</Typography>;
}));

CalendarErrorMessage.defaultProps = {
  children: undefined,
  theme: {}
};

CalendarErrorMessage.displayName = 'CalendarErrorMessage';

export default CalendarErrorMessage;
